import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a2981e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-5 text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-3" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Loading...")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Filter assets", -1))
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" By default only assets uploaded by a distributed user will be processed. Select the checkbox to also process assets uploaded by other users. ")
const _hoisted_9 = { class: "form-check mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Process assets uploaded by all users ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Image formats", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add image formats with actions to run automatically on all uploaded image assets.", -1))
const _hoisted_13 = { class: "d-flex flex-row" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "formatName",
  class: "form-label"
}, "Format name", -1))
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "order" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-arrow-up" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-arrow-down" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-trash" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "action-label" }, "AutoCrop", -1))
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "autoCropBorder",
  class: "form-label"
}, "Keep border", -1))
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "action-label" }, "SmartCrop", -1))
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "smartCropWidth",
  class: "form-label"
}, "Width", -1))
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "smartCropHeight",
  class: "form-label"
}, "Height", -1))
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "action-label" }, "Fit to size", -1))
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "resizeWidth",
  class: "form-label"
}, "Width", -1))
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "resizeHeight",
  class: "form-label"
}, "Height", -1))
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "form-check" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "keepaspectratio"
}, " Autofit inside width / height ", -1))
const _hoisted_48 = {
  key: 0,
  class: "form-check"
}
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "addpadding"
}, " Add padding ", -1))
const _hoisted_51 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "bgColor",
  class: "form-label"
}, "Background color", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "color",
  class: "form-control form-control-color",
  id: "bgColor",
  value: "#563d7c",
  title: "Choose your color"
}, null, -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "action-label" }, "Imagga API Crop", -1))
const _hoisted_56 = { class: "mb-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "resizeWidth",
  class: "form-label"
}, "Width", -1))
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = { class: "mb-3" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "resizeHeight",
  class: "form-label"
}, "Height", -1))
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = {
  key: 4,
  width: "100%"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Client"),
    /*#__PURE__*/_createElementVNode("th", null, "Custom Property"),
    /*#__PURE__*/_createElementVNode("th", null, "Value")
  ])
], -1))
const _hoisted_64 = { width: "30%" }
const _hoisted_65 = { width: "35%" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_70 = { width: "35%" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = { class: "mt-4 d-flex flex-row" }
const _hoisted_75 = { class: "dropdown" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Add action ", -1))
const _hoisted_77 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-row" }, null, -1))
const _hoisted_83 = {
  key: 0,
  class: "modal show",
  tabindex: "-1"
}
const _hoisted_84 = { class: "modal-dialog" }
const _hoisted_85 = { class: "modal-content" }
const _hoisted_86 = { class: "modal-header" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Preview images", -1))
const _hoisted_88 = { class: "modal-body" }
const _hoisted_89 = ["src"]
const _hoisted_90 = {
  key: 1,
  class: "fa fa-spin fa-spinner fa-2x d-inline-block m-5"
}
const _hoisted_91 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.all_users) = $event)),
                "true-value": true,
                "false-value": false,
                id: "flexCheckDefault"
              }, null, 512), [
                [_vModelCheckbox, _ctx.all_users]
              ]),
              _hoisted_10
            ])
          ]),
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addFormat && _ctx.addFormat(...args)))
            }, "Add format"),
            _createElementVNode("button", {
              class: "btn btn-primary ms-3",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startTest()))
            }, "Test actions")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formats, (format, formatIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: formatIdx,
              class: "format"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "formatName",
                  "onUpdate:modelValue": ($event: any) => ((format.name) = $event)
                }, null, 8, _hoisted_16), [
                  [_vModelText, format.name]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(format.actions, (action, actionIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: actionIdx,
                  class: "action"
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "btn btn-light me-2",
                      onClick: ($event: any) => (_ctx.moveAction(formatIdx, actionIdx, 'up'))
                    }, _hoisted_20, 8, _hoisted_18),
                    _createElementVNode("button", {
                      class: "btn btn-light me-2",
                      onClick: ($event: any) => (_ctx.moveAction(formatIdx, actionIdx, 'down'))
                    }, _hoisted_23, 8, _hoisted_21),
                    _createElementVNode("button", {
                      class: "btn btn-light",
                      onClick: ($event: any) => (format.actions.splice(actionIdx, 1))
                    }, _hoisted_26, 8, _hoisted_24)
                  ]),
                  (action.action == 'autocrop')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "autoCropBorder",
                            "onUpdate:modelValue": ($event: any) => ((action.border) = $event)
                          }, null, 8, _hoisted_30), [
                            [_vModelText, action.border]
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (action.action == 'smartcrop')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "smartCropWidth",
                            "onUpdate:modelValue": ($event: any) => ((action.width) = $event)
                          }, null, 8, _hoisted_34), [
                            [_vModelText, action.width]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "smartCropHeight",
                            "onUpdate:modelValue": ($event: any) => ((action.height) = $event)
                          }, null, 8, _hoisted_37), [
                            [_vModelText, action.height]
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (action.action == 'resize')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "resizeWidth",
                            "onUpdate:modelValue": ($event: any) => ((action.width) = $event)
                          }, null, 8, _hoisted_41), [
                            [_vModelText, action.width]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "resizeHeight",
                            "onUpdate:modelValue": ($event: any) => ((action.height) = $event)
                          }, null, 8, _hoisted_44), [
                            [_vModelText, action.height]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: "",
                            id: "keepaspectratio",
                            "onUpdate:modelValue": ($event: any) => ((action.keepaspectratio) = $event),
                            "true-value": true,
                            "false-value": false
                          }, null, 8, _hoisted_46), [
                            [_vModelCheckbox, action.keepaspectratio]
                          ]),
                          _hoisted_47
                        ]),
                        (action.keepaspectratio)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                value: "",
                                id: "addpadding",
                                "onUpdate:modelValue": ($event: any) => ((action.addpadding) = $event),
                                "true-value": true,
                                "false-value": false
                              }, null, 8, _hoisted_49), [
                                [_vModelCheckbox, action.addpadding]
                              ]),
                              _hoisted_50
                            ]))
                          : _createCommentVNode("", true),
                        (action.keepaspectratio && action.addpadding)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_54))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (action.action == 'imaggacrop')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "resizeWidth",
                            "onUpdate:modelValue": ($event: any) => ((action.width) = $event)
                          }, null, 8, _hoisted_58), [
                            [_vModelText, action.width]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "resizeHeight",
                            "onUpdate:modelValue": ($event: any) => ((action.height) = $event)
                          }, null, 8, _hoisted_61), [
                            [_vModelText, action.height]
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (action.action == 'setcustomfield')
                    ? (_openBlock(), _createElementBlock("table", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, clientIdx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: clientIdx }, [
                              _createElementVNode("td", _hoisted_64, _toDisplayString(client.clientName), 1),
                              _createElementVNode("td", _hoisted_65, [
                                (client.auth)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      class: "form-control form-override",
                                      "onUpdate:modelValue": ($event: any) => ((action.updateCustomProp[client.clientId]) = $event)
                                    }, [
                                      _hoisted_67,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.customProps, (prop, propIdx) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: propIdx,
                                          value: prop.fieldName
                                        }, _toDisplayString(prop.label.en), 9, _hoisted_68))
                                      }), 128))
                                    ], 8, _hoisted_66)), [
                                      [_vModelSelect, action.updateCustomProp[client.clientId]]
                                    ])
                                  : (_openBlock(), _createElementBlock("div", _hoisted_69, " Could'nt retrieve custom properties for this client. The user which authenticated the app is probably not authorized. "))
                              ]),
                              _createElementVNode("td", _hoisted_70, [
                                (action.updateCustomProp[client.clientId])
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.customPropData(action, client).fieldType === 'PICKLIST')
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 0,
                                            class: "form-control form-override",
                                            "onUpdate:modelValue": ($event: any) => ((action.updateCustomPropValue[client.clientId]) = $event)
                                          }, [
                                            _hoisted_72,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customPropData(action, client)
                                                        .options, (option, optionIdx) => {
                                              return (_openBlock(), _createElementBlock("option", { key: optionIdx }, _toDisplayString(option), 1))
                                            }), 128))
                                          ], 8, _hoisted_71)), [
                                            [_vModelSelect, action.updateCustomPropValue[client.clientId]]
                                          ])
                                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 1,
                                            "onUpdate:modelValue": ($event: any) => ((action.updateCustomPropValue[client.clientId]) = $event),
                                            type: "text",
                                            class: "form-control"
                                          }, null, 8, _hoisted_73)), [
                                            [_vModelText, action.updateCustomPropValue[client.clientId]]
                                          ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("ul", _hoisted_77, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.addAction(formatIdx, 'smartcrop')), ["prevent"])
                      }, "Smart crop", 8, _hoisted_78)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.addAction(formatIdx, 'resize')), ["prevent"])
                      }, "Fit to size", 8, _hoisted_79)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.addAction(formatIdx, 'imaggacrop')), ["prevent"])
                      }, "Imagga API Crop", 8, _hoisted_80)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.addAction(formatIdx, 'setcustomfield')), ["prevent"])
                      }, "Set custom field", 8, _hoisted_81)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128)),
          _hoisted_82,
          _createElementVNode("form", null, [
            _createElementVNode("input", {
              type: "file",
              style: {"width":"0","height":"0"},
              ref: "fileUpload",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.executeTest()))
            }, null, 544)
          ]),
          (_ctx.previewImages.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _hoisted_87,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewImages.splice(0)))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewImages, (image, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: "preview-image"
                        }, [
                          _createElementVNode("h3", null, _toDisplayString(image.name), 1),
                          (image.src)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                style: {"border":"1px solid"},
                                src: image.src
                              }, null, 8, _hoisted_89))
                            : (_openBlock(), _createElementBlock("span", _hoisted_90))
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.previewImages.splice(0)))
                      }, " Close ")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}